import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView, StyleSheet } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, splashStyles } from '../theme/styles'
import TextView from "../components/TextView";
import { aboutussRequest } from "../utils/api";
import { hp } from "../utils/responsive";
import WebView from "react-native-webview";

const styles = StyleSheet.create({
    a: {
        fontWeight: '300',
        color: '#FF3366', // make links coloured pink
    },
    p: {
        lineHeight: hp(4),
        margin: 10,
        fontFamily: 'IRANSansMobile',

        textAlign: 'right',
    }
});
export default class AboutUsScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            aboutUs: '',
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>درباره آد</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <ScrollView  contentContainerStyle={{ padding: 5,minHeight:hp(90) }}>
                <Image source={icons['splash']} style={[splashStyles.image, { alignSelf: 'center', marginBottom: 20 }]} />
                <WebView
                    source={{html: this.state.aboutUs}}
                />
            </ScrollView>
        </View>)
    }
    componentWillMount() {
        aboutussRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    aboutUs: response.data.aboutus
                })
            }
        })
    }

}
